module.exports = __webpack_public_path__ + "static/media/bg.43f1706b.png";